import { ReactNode } from 'react';
import cx from 'classnames';

type HeaderProps = {
    left?: ReactNode | ReactNode[];
    center?: ReactNode | ReactNode[];
    right?: ReactNode | ReactNode[];
} & React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLDivElement>,
    HTMLDivElement
>;
export const Header = ({
    left,
    center,
    right,
    className,
    ...props
}: HeaderProps) => {
    return (
        <div
            className={cx(
                'flex sticky left-0 right-0 justify-between items-center text-woodyBrown bg-lightPeach py-2 sm:pb-0 px-4 md:px-6 z-40 border-b border-woodyBrown/20 sm:border-none',
                className,
            )}
            {...props}
        >
            <nav className="inline-flex justify-start items-center gap-2 w-1/3">
                {left}
            </nav>
            <nav className="inline-flex justify-center items-center gap-2">
                {center}
            </nav>
            <div className="inline-flex justify-end items-center gap-2 w-1/3">
                {right}
            </div>
        </div>
    );
};
